import React, { FC } from "react"
import Cleave from "cleave.js/react"
import { useField } from "formik"
import clsx from "clsx"

interface FormikDateProps {
  name: string
  className?: string
  inputClassName?: string
}

export const FormikDate: FC<FormikDateProps> = ({ className, inputClassName, name }) => {
  const [field, meta] = useField(name)
  const errorText = meta.error

  return (
    <div className={clsx("relative", className)}>
      <Cleave
        options={{
          date: true,
          datePattern: ["m", "Y"],
          delimiter: "/",
        }}
        {...field}
        placeholder="MM/YYYY"
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded w-full border-2 border-grey-ec sm:text-base text-sm",
          "focus:outline-none focus:shadow-outline focus:border-green active:shadow-outline active:border-green",
          field.value && !errorText && "border-2 !border-green",
          errorText && "!border-red border"
        )}
      />
      {errorText && <small className="text-red absolute -bottom-4 left-0">{errorText}</small>}
    </div>
  )
}
